import { Box, Grid, Typography} from "@material-ui/core";
import PlaneIcon from "../../../../assets/img/plane2.svg";
import CheckGreenIcon from "../../../../assets/img/check-green.svg";
import StepperIcon from "../../../../assets/img/stepper.svg";
import SeatImage from "../../../../assets/img/seat.png";
import FormOperator from "../../../../components/FormOperator/FormOperator";
import writtenNumber from "written-number";
import useStyles from "./styles";


const ThankYouPage = ({
  selectedFlight,
  apiData,
  airports,
  passengers,
  total,
}) => {
  const classes = useStyles();

  const numberToWrittenString = () => {
    const splittedPrice = total.split(".");
    return (
        <>{`(${writtenNumber(splittedPrice[0])} US dollars and ${writtenNumber(
            splittedPrice[1]
        )} cents)`}</>
    );
  };

  const calculatePassengerType = (departureDate, dateOfBirth) => {
    const birthDate = new Date(dateOfBirth);
    const departure = new Date(departureDate * 1000);
    const ageInMilliseconds = departure - birthDate;
    const ageInYears = ageInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);

    if (ageInYears < 2) {
      return 'Infant';
    } else if (ageInYears < 12) {
      return 'Child';
    } else {
      return 'Adult';
    }
  }

  return (
     <Grid container style={{ height: "100%" }}>
       {/*Main screen*/}
       <Grid item xs={12} md={8} className={classes.leftPanel}>
         <Box className={classes.leftPanelContent}>
           <Box className={classes.planeIcon}>
             <img src={PlaneIcon} alt="plane" />
           </Box>
           <Typography className={classes.title}>
             Thank you for booking with
           </Typography>
           <Typography variant="h1" align="center" style={{ marginBottom: "16px" }}>
           {process.env.REACT_APP_PROJECT === 'tbc' ? 'Travel Business Class' :
            (process.env.REACT_APP_PROJECT === 'abt' ? 'Air Business Travel' :
              (process.env.REACT_APP_PROJECT === 'bcf' ? 'Business Class Fares' :
                process.env.REACT_APP_PROJECT === 'abf' ? 'Air Business Flights' : 
                'us'
              )
            )
           }!
           </Typography>
           <Typography className={classes.subtitleText}>
             Your gateway to exclusive business and first-class deals with exceptional personal service for a seamless travel experience.
           </Typography>

           <Box className={classes.tickTextWrapper}>
             <img src={CheckGreenIcon} alt="tick" style={{ marginRight: "8px" }}/>
             <Typography style={{ fontWeight: "bold", fontSize: "18px", marginRight: "6px" }}>Your order number:</Typography>
             <Typography style={{ fontWeight: "bold", fontSize: "18px", color: "#4A94EC"}}>#{ apiData.lead_id ?? selectedFlight?.id }</Typography>
           </Box>
           <Typography>Your payment was successfully processed!</Typography>

           <Box className={classes.tickTextWrapper}>
             <img src={CheckGreenIcon} alt="tick" style={{ marginRight: "8px" }}/>
             <Typography style={{ fontWeight: "bold", fontSize: "18px" }}>24/7 Live Support</Typography>
           </Box>
           <Typography align="center" style={{ maxWidth: "360px" }}>
             Your personal travel advisor, <b>{apiData?.operatorInfo?.name}</b>, will contact you shortly.
           </Typography>
         </Box>
         <img src={SeatImage} className={classes.seatImage} alt="seat"/>
       </Grid>

       {/*Sidebar screen*/}
       <Grid item xs={12} md={4} className={classes.rightPanel}>
         <Box
           display="flex"
           flexDirection="column"
           justifyContent="center"
           alignItems="center"
           mb={2}
         >
           <Typography className={classes.title}>Booking Summary</Typography>
           <Typography style={{ fontSize: "24px", fontWeight: "bold" }}>Your travel details</Typography>
         </Box>

         {/*Depart*/}
         {selectedFlight?.parts?.hasOwnProperty("depart") && Object.keys(selectedFlight?.parts?.depart)?.length > 0 && (
           <>
            <Box className={classes.flightCard}>
             <Box className={classes.itinerary}>
               <Box display="flex">
                 <img src={StepperIcon} alt="stepper" className={classes.stepperIcon} />

                 <Box display="flex" flexDirection="column" style={{ paddingLeft: "8px", marginTop:"-6px", gap: "20px" }}>
                   <Typography>
                     From <b>{`${airports[selectedFlight.parts.depart.from]?.city || ""}
                  (${selectedFlight.parts.depart.from || ""})`}</b>
                   </Typography>
                   <Typography>
                     To <b>{`${airports[selectedFlight.parts.depart.to]?.city || ""}
                   (${selectedFlight.parts.depart.to || ""})`}</b>
                   </Typography>
                 </Box>
                 </Box>
               <Box>
                 {selectedFlight?.parts?.depart && (
                   <Typography style={{ color: "#71777D", marginTop: "-6px" }}>
                     Departure: <span style={{color: "#282F36"}}>{selectedFlight?.parts?.depart?.date}</span>
                   </Typography>
                 )}
               </Box>
             </Box>
             <Box
               display="flex"
               flexDirection="column"
               gap="12px"
             >
               {passengers?.map((passenger, index) => (
                 <Box className={classes.passengerInfo} key={index}>
                   <Box>
                     <Typography style={{ color: "#4A94EC", fontSize: "12px", fontWeight:"bold", paddingBottom: "4px" }}>
                       PASSENGER {index + 1}
                     </Typography>
                     <Typography style={{ color: "#333333", fontWeight: "bold" }}><b>{ `${passenger.firstName} ${passenger.lastName}` }</b></Typography>
                   </Box>
                   <Typography style={{ color: "#71777D", display: "flex", alignItems: "center" }}>
                     { calculatePassengerType(selectedFlight?.parts?.depart?.departure_at, passenger.birthDate) }
                     <div style={{ color: "#B4B4B4", fontSize: "24px", margin: "0 8px" }}>•</div>
                     <span style={{ color: "#282F36" }}>{selectedFlight?.parts?.depart?.flightClass} Class</span>
                   </Typography>
                 </Box>
               ))}
             </Box>
            </Box>
           </>
         )}

         {/*Return*/}
         {selectedFlight?.parts?.hasOwnProperty("return") && Object.keys(selectedFlight?.parts?.return)?.length > 0 && (
           <>
            <Box className={classes.flightCard}>
             <Box className={classes.itinerary}>
               <Box display="flex">
                 <img src={StepperIcon} alt="stepper" className={classes.stepperIcon} />

                 <Box display="flex" flexDirection="column" style={{ paddingLeft: "8px", marginTop:"-6px", gap: "20px" }}>
                   <Typography>
                     From <b>{`${airports[selectedFlight.parts.return.from]?.city || ""}
                        (${selectedFlight.parts.return.from || ""})`}</b>
                   </Typography>
                   <Typography>
                     To <b>{`${airports[selectedFlight.parts.return.to]?.city || ""}
                        (${selectedFlight.parts.return.to || ""})`}</b>
                   </Typography>
                 </Box>
               </Box>
               <Box>
                 {selectedFlight?.parts?.return && (
                   <Typography style={{ color: "#71777D", marginTop: "-6px" }}>
                     Return: <span style={{ color: "#282F36" }}>{ selectedFlight?.parts?.return?.date }</span>
                   </Typography>
                 )}
               </Box>
             </Box>

             <Box
               display="flex"
               flexDirection="column"
               gap="12px"
             >
               {passengers?.map((passenger, index) => (
                 <Box className={classes.passengerInfo} key={index}>
                   <Box>
                     <Typography style={{ color: "#4A94EC", fontSize: "12px", fontWeight:"bold", paddingBottom: "4px" }}>
                       PASSENGER {index + 1}
                     </Typography>
                     <Typography style={{ color: "#333333", fontWeight: "bold" }}><b>{ `${passenger.firstName} ${passenger.lastName}` }</b></Typography>
                   </Box>
                   <Typography style={{color: "#71777D", display: "flex", alignItems: "center" }}>
                     {calculatePassengerType(selectedFlight?.parts?.return?.departure_at, passenger.birthDate)}
                     <div style={{color: "#B4B4B4", fontSize: "24px", margin: "0 8px"}}>•</div>
                     <span style={{color: "#282F36"}}>{selectedFlight?.parts?.return?.flightClass} Class</span>
                   </Typography>
                 </Box>
               ))}
             </Box>
            </Box>
           </>
         )}

         {/* Multicity */}
         {selectedFlight?.parts?.multiple?.map((part, index) => (
           <Box key={index} className={classes.flightCard}>
             <Box className={classes.itinerary}>
               <Box>
                 <Box display="flex">
                   <img src={StepperIcon} alt="stepper" className={classes.stepperIcon} />

                   <Box display="flex" flexDirection="column" style={{ paddingLeft: "8px", marginTop: "-6px", gap: "20px" }}>
                     <Typography>
                       From <b>{`${airports[part.from]?.city || ""} (${part.from || ""})`}</b>
                     </Typography>
                     <Typography>
                       To <b>{`${airports[part.to]?.city || ""} (${part.to || ""})`}</b>
                     </Typography>
                   </Box>
                 </Box>
               </Box>
               <Box>
                 <Typography style={{ color: "#71777D", marginTop: "-6px" }}>
                   Departure: <span style={{ color: "#282F36" }}>{part.date}</span>
                 </Typography>
               </Box>
             </Box>

             <Box display="flex" flexDirection="column" gap="12px">
               {apiData.result?.passengers?.map((passenger, index) => (
                 <Box className={classes.passengerInfo} key={index}>
                     <Box key={index}>
                       <Typography style={{ color: "#4A94EC", fontSize: "12px", fontWeight: "bold", paddingBottom: "4px" }}>
                         PASSENGER {index + 1}
                       </Typography>
                       <Typography style={{ color: "#333333", fontWeight: "bold" }}>
                         <b>{`${passenger.firstName} ${passenger.lastName}`}</b>
                       </Typography>
                     </Box>
                   <Typography style={{color: "#71777D", display: "flex", alignItems: "center"}}>
                     {calculatePassengerType(selectedFlight?.parts?.multiple?.departure_at, passenger.birthDate)}
                     <div style={{color: "#B4B4B4", fontSize: "24px", margin: "0 8px"}}>•</div>
                     <span style={{color: "#282F36"}}>{part.flightClass} Class</span>
                   </Typography>
                 </Box>
               ))}
             </Box>
           </Box>
         ))}

         <Grid container>
           <Box className={classes.totalPrice}>
             <Grid item xs={12} md={6}>
             <Typography style={{ fontWeight: "bold", fontSize: "24px", marginBottom: "10px" }}>
               Total price paid:
             </Typography>
             </Grid>
             <Grid item xs={12} md={6}>
               <Box display="flex" flexDirection="column">
                 <Typography variant="h1" className={classes.totalSum}>
                   {`$ ${total}`}
                 </Typography>
                 <Typography className={classes.totalCaption}>
                   {numberToWrittenString()}
                 </Typography>
               </Box>
            </Grid>
           </Box>
         </Grid>

         <Box className={classes.operatorInfo}>
           <FormOperator operatorInfo={apiData?.operatorInfo} showOnMobile={true} />
         </Box>
       </Grid>
     </Grid>
  )
}

export default ThankYouPage;
